import type { ReactNode } from "react";

import { ConsentBanner } from "@/components/core/consent-banner";
import { Footer } from "@/components/core/footer";
import { Navbar } from "@/components/core/navbar";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { SkipLink } from "@/components/ui/skip-link";
import { useSiteContent, useSiteShared } from "@/config/use-site-content";
import { useT } from "@/i18n/locale-context";
import { createThemeStyle } from "@/lib/site-config";

interface LayoutShellProps {
  children: ReactNode;
}

export function LayoutShell({ children }: LayoutShellProps): JSX.Element {
  const content = useSiteContent();
  const shared = useSiteShared();
  const t = useT();

  return (
    <div style={createThemeStyle(shared.theme)}>
      <SkipLink>{t("common.skipToContent")}</SkipLink>
      <Navbar
        action={content.headerAction}
        items={content.navigation}
        siteName={content.site.name}
      />
      <main
        id="main"
        tabIndex={-1}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
      <Footer
        groups={content.footerGroups}
        siteName={content.site.name}
        tagline={content.site.tagline}
      />
      <ConsentBanner />
    </div>
  );
}
